import { Component } from 'react'
import PropTypes from 'prop-types'
import { getSlightlyContrastingColor } from '@helpers/color_scheme_helpers.js'
import { ThemeContext } from '../../../../base/ThemeContext'

export default class Surface extends Component {
  render() {
    const { x, y, width, height, cursor } = this.props
    const colorScheme = this.context
    const backgroundColor = getSlightlyContrastingColor(colorScheme.primary, colorScheme)
    const style = {
      x,
      y,
      width,
      height,
      cursor,
      backgroundColor,
    }
    return <div className="surface" style={style}></div>
  }
}
Surface.contextType = ThemeContext
Surface.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  cursor: PropTypes.string.isRequired,
}
Surface.defaultProps = {
  cursor: 'auto',
}
